import { FC } from "react";
import { Progress } from "../../../../redux/types";
import { Stepper, Step, StepLabel } from "@mui/material";

interface ProgresProps {
  progress?: Progress[];
  onProgressChange?: (progressId: number, checked: boolean) => void;
}

export const ProgressSlider: FC<ProgresProps> = ({ progress, onProgressChange }) => {
  // Sort progress by step ascending
  const sortedProgress = Array.isArray(progress)
    ? [...progress].sort((a, b) => a.step - b.step)
    : [];

  // Accept callback from parent
  const handleCheckboxChange = (progressId: number, checked: boolean) => {
    if (typeof onProgressChange === "function") {
      onProgressChange(progressId, checked);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <div 
        style={{ 
          textAlign: "center", 
          color: "#ef4444", 
          fontSize: "clamp(0.75rem, 2vw, 0.95rem)", 
          fontWeight: 500,
          marginBottom: "12px",
          padding: "0 12px",
          lineHeight: "1.5",
        }}
      >
        <span>
          Note: Progress will be marked as completed only when all the sections for each step are done.
        </span>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          justifyContent: window.innerWidth < 768 ? "flex-start" : "center",
          gap: "clamp(4px, 1vw, 8px)",
          padding: "8px 0",
          borderRadius: "10px",
          overflowX: "auto",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "thin",
        }}
      >
        {sortedProgress.map((step, idx) => (
          <div
            key={step.id}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              minWidth: window.innerWidth < 768 ? "140px" : "120px",
              maxWidth: "180px",
              padding: "0 clamp(8px, 1.5vw, 12px)",
              position: "relative",
              flexShrink: 0,
            }}
          >
            <label 
              style={{ 
                display: "flex", 
                alignItems: "center", 
                gap: "8px", 
                marginBottom: 2,
                cursor: "pointer",
                userSelect: "none",
                WebkitTapHighlightColor: "transparent",
              }}
            >
              <input
                type="checkbox"
                checked={step.completed}
                onChange={e => handleCheckboxChange(step.id, e.target.checked)}
                style={{
                  width: window.innerWidth < 768 ? 16 : 18,
                  height: window.innerWidth < 768 ? 16 : 18,
                  accentColor: step.completed ? "#4b87ed" : "#bbb",
                  cursor: "pointer",
                  marginBottom: 0,
                  flexShrink: 0,
                }}
              />
              <span style={{
                fontWeight: 500,
                fontSize: window.innerWidth < 768 ? "0.875rem" : "1rem",
                color: step.completed ? "#4b87ed" : "#1f2937",
                letterSpacing: "0.01em",
                whiteSpace: "nowrap",
                lineHeight: "1.2",
              }}>
                {step.title}
              </span>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
